import { ExperienceSortFields, SortDirection, useExperiencesQuery } from '@/generated/graphql';
import { useExperienceFilter } from './use-experience-filter';

export function useExploreQuery() {
  const { filter: experienceFilter } = useExperienceFilter();
  return useExperiencesQuery({
    variables: {
      sorting: {
        field: ExperienceSortFields.Next,
        direction: SortDirection.Asc,
      },
      filter: {
        ...experienceFilter,
      },
    },
  });
}

export function useExploreLimitQuery({ limit }: { limit: number }) {
  const { filter: experienceFilter } = useExperienceFilter();
  return useExperiencesQuery({
    variables: {
      sorting: {
        field: ExperienceSortFields.Next,
        direction: SortDirection.Asc,
      },
      filter: {
        ...experienceFilter,
      },
      paging: {
        first: limit,
      },
    },
  });
}
